import { SvgIcon } from '@material-ui/core'
import React from 'react'

export default function CloseIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <path d="M12,0.375C5.578,0.375 0.375,5.578 0.375,12C0.375,18.422 5.578,23.625 12,23.625C18.422,23.625 23.625,18.422 23.625,12C23.625,5.578 18.422,0.375 12,0.375ZM17.7,15.052C17.92,15.272 17.92,15.628 17.7,15.848L15.844,17.7C15.623,17.92 15.267,17.92 15.047,17.7L12,14.625L8.948,17.7C8.728,17.92 8.372,17.92 8.152,17.7L6.3,15.844C6.08,15.623 6.08,15.267 6.3,15.047L9.375,12L6.3,8.948C6.08,8.728 6.08,8.372 6.3,8.152L8.156,6.295C8.377,6.075 8.733,6.075 8.953,6.295L12,9.375L15.052,6.3C15.272,6.08 15.628,6.08 15.848,6.3L17.705,8.156C17.925,8.377 17.925,8.733 17.705,8.953L14.625,12L17.7,15.052Z" />
    </SvgIcon>
  )
}